import { jsx, jsxs } from "react/jsx-runtime";
import { Stack, Tooltip } from "@mui/material";
import { WorkWave } from "../../../../../icons/logos/index.js";
import { LoginPrimaryAction } from "../../../LoginPrimaryAction/LoginPrimaryAction.js";
import { loginForm } from "../../loginFormSetup.js";
import { useTexts } from "./useTexts.js";
function LoginSSOButton(props) {
  const {
    buttonProps,
    autoFocus,
    icon = /* @__PURE__ */ jsx(WorkWave, { width: 24, variant: "icon", mode: "contrast" }),
    loading,
    loaderColor = "#ffffff"
  } = props;
  const {
    meta: { submitting }
  } = loginForm.useFormMeta();
  const texts = useTexts();
  return /* @__PURE__ */ jsx(Tooltip, { title: texts.tooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
    LoginPrimaryAction,
    {
      label: /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "center", gap: 1, children: [
        icon,
        texts.label
      ] }),
      testId: "ssoLoginBtn",
      disabled: submitting,
      autoFocus,
      componentProps: { ...buttonProps, type: "button" },
      loading,
      loaderColor
    }
  ) }) });
}
export {
  LoginSSOButton
};
//# sourceMappingURL=LoginSSOButton.js.map
